import debug from 'debug';

const log = debug('fus078/polyfills');

System.import(
	/* webpackChunkName: "vendor/svg4everybody@2.0.0" */
	'@vendor/svg4everybody@2.0.0'
	).then((svg4everybody) => {
		log('polyfilled.svg4everybody', svg4everybody);
		svg4everybody();
	});


// WEBPACK FOOTER //
// ./client/src/site__fus078/polyfills/svg.polyfill.js